import {EntityType, PropertyDefinition, PropertyDefinitionConfig} from '../types';

export const TEMPLATE_PROPERTY_TEXT_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idPropertyDefinitionTextRepository',
	singular: 'Long Text Field',
	summary: 'Multi-line text.',
};

export const TEMPLATE_PROPERTY_TEXT_TEMPLATE_PROPERTIES: PropertyDefinition[] = [{
	id: 'idPropertyDefinitionTextTemplateTitleProperty',
	parentId: TEMPLATE_PROPERTY_TEXT_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'label',
	label: 'Label',
	required: true,
	autoFocus: true,
}, {
	id: 'idPropertyDefinitionTextTemplateSlugProperty',
	parentId: TEMPLATE_PROPERTY_TEXT_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'slug',
	label: 'Key',
	required: true,
	disabled: true,
}, {
	id: 'idPropertyDefinitionTextTemplateRequiredProperty',
	parentId: TEMPLATE_PROPERTY_TEXT_REPOSITORY.id,
	type: EntityType.PropertyDefinitionBoolean,
	slug: 'required',
	label: 'Required',
	required: true,
	defaultChecked: true,
}];
